"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_router_dom_1 = require("react-router-dom");
//
// components
//
const Profile = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Profile'))));
const Security = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Security'))));
const TabNavigation = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../TabNavigation'))));
const LoadingSpinner_1 = __importDefault(require("../../general/LoadingSpinner"));
//
// styles
//
const StyledHeader_1 = require("./StyledHeader");
const StyledContent_1 = require("./StyledContent");
const StyledContainer_1 = require("./StyledContainer");
const StyledMessageContainer_1 = require("../StyledMessageContainer");
const leftTab = {
    description: 'profile-link',
    label: 'Profile',
    link: '/settings/profile'
};
const rightTab = {
    description: 'security-link',
    label: 'Security',
    link: '/settings/security'
};
const tabs = [leftTab, rightTab];
const Settings = () => {
    return (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
            react_1.default.createElement(LoadingSpinner_1.default, null)) },
        react_1.default.createElement(StyledContainer_1.StyledContainer, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(StyledHeader_1.StyledHeader, null, "Settings"),
                react_1.default.createElement(TabNavigation, { tabs: tabs })),
            react_1.default.createElement("div", null,
                react_1.default.createElement(StyledContent_1.StyledContent, null,
                    react_1.default.createElement(react_router_dom_1.Switch, null,
                        react_1.default.createElement(react_router_dom_1.Route, { path: '/settings/profile' },
                            react_1.default.createElement(Profile, null)),
                        react_1.default.createElement(react_router_dom_1.Route, { path: '/settings/security' },
                            react_1.default.createElement(Security, null)),
                        react_1.default.createElement(react_router_dom_1.Redirect, { to: '/settings/profile' })))))));
};
Settings.propTypes = {
    onLogout: prop_types_1.default.func
};
exports.default = Settings;
